import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const CART_URL = 'https://italia.kitonline.shop/cart/44568283611271:1';
export function PricingCard() {
  return <section id="pricing" className="py-10 sm:py-14 px-4 relative scroll-mt-10" data-id="element-184">
      <div className="absolute inset-0 bg-brand-orange/15 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-185" />

      <div className="max-w-md sm:max-w-lg mx-auto relative z-10" data-id="element-186">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl font-black text-center mb-6 text-brand-cream" data-id="element-187">
          L'Offerta Completa
        </motion.h2>

        {/* Outer gradient frame for high contrast against dark bg */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative rounded-3xl p-[2px] bg-gradient-to-b from-brand-orange via-brand-amber to-brand-gold shadow-[0_0_60px_rgba(249,115,22,0.35)]" data-id="element-188">
          <div className="bg-gradient-to-b from-[#1a0f0a] to-[#0d0703] rounded-3xl relative overflow-hidden" data-id="element-189">
            {/* Subtle glow inside */}
            <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-72 h-72 bg-brand-orange/20 blur-[80px] rounded-full pointer-events-none" data-id="element-190" />

            {/* Top badge */}
            <div className="flex justify-center pt-4 pb-1 relative z-10" data-id="element-191">
              <div className="bg-gradient-to-r from-brand-orange to-brand-amber text-white font-black px-5 py-1.5 rounded-full flex items-center gap-1.5 uppercase tracking-wide text-xs shadow-[0_0_20px_rgba(249,115,22,0.6)]" data-id="element-192">
                <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-193" />
                IL PIÙ SCELTO DAI DOCENTI
              </div>
            </div>

            <div className="p-6 sm:p-8 relative z-10" data-id="element-194">
              <h3 className="text-lg sm:text-xl font-black text-center text-brand-cream uppercase mb-6 leading-tight" data-id="element-195">
                Cosa ottieni · Valore
              </h3>

              <div className="space-y-0 mb-5" data-id="element-196">
                {[{
                label: '6 Volumi Opera Omnia (400+ pagine)',
                price: '€120'
              }, {
                label: 'Bonus 1 — Master Excel Correttore',
                price: '€67'
              }, {
                label: 'Bonus 2 — 25 Verifiche con Soluzioni',
                price: '€47'
              }, {
                label: 'Bonus 3 — Kit Griglie MIM',
                price: '€47'
              }, {
                label: 'Bonus 4 — 10 Lezioni Ed. Civica PPT',
                price: '€37'
              }].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-brand-orange/15 py-3 gap-3" data-id="element-197">
                    <span className="text-gray-200 font-medium text-sm sm:text-base" data-id="element-198">
                      {item.label}
                    </span>
                    <span className="text-gray-400 line-through text-sm sm:text-base shrink-0" data-id="element-199">
                      {item.price}
                    </span>
                  </div>)}
                <div className="flex justify-between items-center pt-4" data-id="element-200">
                  <span className="text-base sm:text-lg font-black text-brand-cream uppercase" data-id="element-201">
                    Valore totale:
                  </span>
                  <span className="text-xl sm:text-2xl font-black text-brand-danger line-through" data-id="element-202">
                    €318
                  </span>
                </div>
                <div className="flex justify-between items-center pt-2" data-id="element-203">
                  <span className="text-sm font-bold text-gray-400 uppercase" data-id="element-204">
                    Prezzo di lancio:
                  </span>
                  <span className="text-base font-bold text-gray-400 line-through" data-id="element-205">
                    €97
                  </span>
                </div>
              </div>

              {/* Highlighted price box with strong orange contrast */}
              <div className="relative rounded-2xl p-[2px] bg-gradient-to-r from-brand-orange via-brand-gold to-brand-orange mb-5 shadow-[0_0_30px_rgba(249,115,22,0.5)]" data-id="element-206">
                <div className="bg-[#1a0a04] rounded-2xl p-5 text-center" data-id="element-207">
                  <p className="text-brand-orange font-black text-sm mb-2 uppercase tracking-wide" data-id="element-208">
                    🏆 Offerta di Lancio · Solo Oggi
                  </p>
                  <div className="flex justify-center items-center gap-2 mb-1" data-id="element-209">
                    <span className="text-2xl" data-id="element-210">💥</span>
                    <span className="text-4xl sm:text-5xl font-black bg-gradient-to-r from-brand-orange via-brand-amber to-brand-gold bg-clip-text text-transparent" data-id="element-211">
                      €19,90
                    </span>
                    <span className="text-2xl" data-id="element-212">💥</span>
                  </div>
                  <p className="text-xs text-gray-300 mt-1 font-medium" data-id="element-213">
                    Pagamento unico · Accesso a vita
                  </p>
                </div>
              </div>

              <div className="flex justify-center mb-5" data-id="element-214">
                <div className="inline-flex items-center gap-2 border border-brand-orange/40 bg-brand-orange/10 px-4 py-1.5 rounded-full" data-id="element-215">
                  <ShieldCheckIcon className="w-4 h-4 text-brand-orange" data-id="element-216" />
                  <span className="text-xs font-bold text-brand-orange" data-id="element-217">
                    ⏰ Prezzo di lancio — salirà presto
                  </span>
                </div>
              </div>

              <CTAButton href={CART_URL} className="w-full mb-5" data-id="element-218">
                SÌ! VOGLIO IL METODO COMPLETO
              </CTAButton>

              <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-[11px] sm:text-xs text-gray-400 font-medium" data-id="element-219">
                <span className="flex items-center gap-1" data-id="element-220">
                  <ZapIcon className="w-3 h-3 text-brand-gold" data-id="element-221" /> Accesso
                  Immediato
                </span>
                <span className="text-gray-600" data-id="element-222">•</span>
                <span className="flex items-center gap-1" data-id="element-223">
                  <CreditCardIcon className="w-3 h-3 text-brand-gold" data-id="element-224" />{' '}
                  Pagamento Unico
                </span>
                <span className="text-gray-600" data-id="element-225">•</span>
                <span className="flex items-center gap-1" data-id="element-226">
                  <ShieldCheckIcon className="w-3 h-3 text-brand-gold" data-id="element-227" />{' '}
                  Garanzia 14 Giorni
                </span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}